import * as React from 'react';
import { useMessage } from '../messages/useMessage';
import { useReportService } from '../services/report-service';

export const useReportController = () => {
  const {
    downloadResultReport,
    downloadClassReportPdf,
    getLinkReportClassComplete,
  } = useReportService();
  const { handleError } = useMessage();

  const getResultReport = React.useCallback(
    async (interviewId) => {
      try {
        return await downloadResultReport(interviewId);
      } catch (error) {
        handleError(
          'Erro ao tentar gerar relatório de resultado da entrevista.',
        );
      }
    },
    [downloadResultReport, handleError],
  );

  const getLinkReportClassRoom = React.useCallback(
    async (idClassRoom) => {
      try {
        return await getLinkReportClassComplete(idClassRoom);
      } catch (error) {
        console.error(error);
        handleError(error?.message);
        throw error;
      }
    },
    [getLinkReportClassComplete, handleError],
  );

  const getClassReport = React.useCallback(
    async (interviews) => {
      try {
        return await downloadClassReportPdf(interviews);
      } catch (error) {
        console.error(error);
        handleError(error.message);
      }
    },
    [downloadClassReportPdf, handleError],
  );

  const downloadPdf = React.useCallback((data, reportName) => {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', reportName);
    document.body.appendChild(link);
    link.click();
  }, []);

  return {
    getResultReport,
    downloadPdf,
    getClassReport,
    getLinkReportClassRoom,
  };
};
